import { prependProxyBaseUrl, request } from "api/request";
import { GetWorkflowSchedules } from "./models/requests/GetWorkflowSchedules";
import { WorkflowSchedule } from "types/workflow/workflowSchedule";

const WORKFLOW_SCHEDULING_BASE_ENDPOINT = prependProxyBaseUrl("/api/workflow-schedules");
const SEQUENTIAL_QUEUE_WORKFLOW_SCHEDULING_ENDPOINT = prependProxyBaseUrl("/api/workflow-schedules/sequential-queue-workflow-schedules");

export const getWorkflowsSchedules = async (): Promise<GetWorkflowSchedules> => {
  const response = await request().url(WORKFLOW_SCHEDULING_BASE_ENDPOINT).get().json();

  const validate = GetWorkflowSchedules.validate(response);

  if (validate.success) {
    return validate.value;
  } else {
    console.error(validate.message);
    throw new Error(validate.message);
  }
};

export const getDueSequentialQueueWorkflows = async (): Promise<WorkflowSchedule[]> => {
  const response = await request().url(SEQUENTIAL_QUEUE_WORKFLOW_SCHEDULING_ENDPOINT).headers({ "Cache-Control": "no-cache" }).get().json();

  // The response from the backend is an array of WorkflowSchedule objects.
  // We need to validate each item in the array.
  if (Array.isArray(response)) {
    const validatedResponse = response.map((item) => {
      const validate = WorkflowSchedule.validate(item);
      if (validate.success) {
        return validate.value;
      } else {
        console.error("Validation error for workflow schedule item:", validate.message);
        throw new Error(validate.message);
      }
    });
    return validatedResponse;
  } else {
    console.error("Invalid response format for getDueSequentialQueueWorkflows:", response);
    throw new Error("Invalid response format");
  }
};
